import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import printPdf from 'utils/printPdf';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import TemplatePreviewFillForm from 'components/settings/TemplatePreviewFillForm';

import { fetchTemplate } from 'redux/modules/templates';
import { fetchBusiness } from 'redux/modules/business';

import templateToPDF from 'utils/templateToPDF';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class TemplatePrint extends Component {
  constructor(props) {
    super(props);

    this.onTemplatesRequest = this.onTemplatesRequest.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ isMounted: true });
    this.props.actions.fetchBusiness({
      triggerLoading: true,
    });
    if (!location.state || !location.state.template) {
      this.onTemplatesRequest();
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      loading,
      history,
    } = this.props;
    if (loading > 0
      && nextProps.loading === 0
      && !nextProps.template) {
      history.replace('/settings/templates');
    }
  }

  componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  onTemplatesRequest() {
    const { actions, match } = this.props;
    actions.fetchTemplate({
      ID: Number(match.params.id),
      triggerLoading: true,
    });
  }

  render() {
    const {
      loading,
      business,
      location,
    } = this.props;
    const template = location.state && location.state.template
      ? location.state.template : this.props.template;
    return (
      <Layout
        variant="print"
        {...loading === 0 && template && template.ID ? { navigationSections: [
          {
            title: 'Templates',
            items: [
              {
                title: template.Name,
                href: `/settings/templates/${template.ID}/print`,
              },
            ],
          },
        ] } : {}}
        {...loading === 0 && template && !template.ID ? { navigationSections: [
          {
            title: 'Templates',
            items: [
              {
                title: template.Name,
                href: '/settings/templates/create/print',
                state: location.state,
              },
            ],
          },
        ] } : {}}
        titleText="Print Preview"
      >
        {loading > 0 ? (
          <Progress />
        ) : (
          <Fragment>
            {template &&
              <Fragment>
                <Helmet>
                  <title>
                    {appTitle} {titleSeparator} Template Print {titleSeparator} {template.Name}
                  </title>
                </Helmet>
                <TemplatePreviewFillForm
                  form={template.ID ? `${template.ID}-templatePreviewFill` : 'create-templatePreviewFill'}
                  template={template}
                  business={business}
                  initialValues={{
                    Name: template.Name,
                  }}
                  onSubmitCustom={printOnSubmitSuccess =>
                    values => templateToPDF({
                      template,
                      business,
                      values,
                    }).then(PDF => ({
                      blob: PDF.output('blob'),
                      Name: values.Name,
                      printOnSubmitSuccess,
                    }))}
                  onSubmitSuccess={(values) => {
                    if (values.printOnSubmitSuccess) {
                      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(values.blob, `${values.Name}.pdf`);
                      } else {
                        printPdf(values.blob);
                      }
                    }
                  }}
                />
              </Fragment>
            }
          </Fragment>
        )}
      </Layout>
    );
  }
}

TemplatePrint.propTypes = {
  template: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }),
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchTemplate: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      template: PropTypes.shape({
        Name: PropTypes.string,
      }),
    }),
  }).isRequired,
};

TemplatePrint.defaultProps = {
  template: null,
};

const mapStateToProps = (store, ownProps) => ({
  templates: store.templates.data,
  business: store.business.data,
  template: store.templates.data.find(item => item.ID === Number(ownProps.match.params.id)),
  loading: store.templates.loading + store.business.loading,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchTemplate, fetchBusiness }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplatePrint);



// WEBPACK FOOTER //
// ./src/pages/settings/TemplatePrint.js